<app-header backgroundImage="assets/header/about-us.webp"
            i18n-title title="Über Uns"
            i18n-description
            description="Lernen Sie unser Team kennen und erfahren Sie, wie sich unsere Firma im Lauf der Geschichte weiterentwickelt und verändert hat."/>

<main>
  <section>
    <div class="card card-padding shear">
      <div class="shear-inner bg-before">
        <div class="inner-content text-center">
          <h1 i18n>Kompetente Beratung und umfangreicher Service</h1>
          <p i18n>
            Die Firma ser.soft GmbH entwickelt professionelle Software und berät Unternehmen kompetent in fast allen Gebieten der IT.
            Dabei können die Mitarbeiter auf ihre langjährige Erfahrung zurückgreifen,
            die sie in mehreren Projekten zusammen mit verschiedenen Kunden erworben haben.<br/>
            Im Jahr 2001 wurde die Firma ser.soft GmbH mit Sitz in zentraler Lage in Karlsruhe gegründet.
            2010 sind wir in unsere neuen Büroräume nach Kürnbach umgezogen.
            Zusammen mit unseren Kooperationspartnern haben wir für namhafte nationale und internationale Unternehmen
            Projekte im Bereich der Konzeption, Implementierung und Einführung von Software durchgeführt.
          </p>
        </div>
      </div>
    </div>
  </section>

  <section>
    <div class="card card-padding shear">
      <div class="shear-inner bg-after bg-color-after">
        <div class="inner-content mx-0">
          <h1 class="text-center mb-5" i18n>Unser Team</h1>
          <div class="row">
            @for (member of team.valueOrDefault(); track member.id) {
              <div class="col-12 col-lg-4 d-flex flex-column align-items-center gap-1 member mt-2 px-3">
                @if (member.images) {
                  <div class="member-img" [class.has-flip-image]="!!member.images.flipSide">
                    @if (member.images.flipSide) {
                      <img class="bottom" [ngSrc]="member.images.flipSide.source" [alt]="member.name" sizes="33vw"
                           [width]="member.images.flipSide.size.width" [height]="member.images.flipSide.size.height"/>
                    }
                    @if (member.images.primary) {
                      <img class="top" [ngSrc]="member.images.primary.source" [alt]="member.name" sizes="33vw"
                           [width]="member.images.primary.size.width" [height]="member.images.primary.size.height"/>
                    }
                  </div>
                } @else {
                  <div class="predefined-member-img">
                    <img [ngSrc]="`assets/images/profile-${member.gender === TeamMemberGender.Female ? 'female' : 'male'}.svg`"
                         [alt]="member.name" width="213" height="188" sizes="33vw"/>
                  </div>
                }
                <h2 class="text-center h3">{{ member.name }}</h2>
                <h3 class="text-center h6 member-roles">{{ member.roles.join(', ') }}</h3>
                <p [innerHTML]="member.introduction | safeHtml"></p>
              </div>
            }
            <div class="col-12 col-lg-4 d-flex flex-column align-items-center gap-1 member mt-2 px-3" id="we-want-you">
              <div class="predefined-member-img">
                <img ngSrc="assets/images/hand-pointing-at-reader.svg" alt="Hand die auf den Leser zeigt" i18n-alt
                     width="1521" height="1517" sizes="33vw"/>
              </div>
              <h2 class="text-center h3" i18n>Du?</h2>
              <h3 class="text-center h6 member-roles" i18n>Entwickler</h3>
              <p i18n>
                Angular und / oder C# (.NET) beherrschst du im Schlaf?<br/>
                Langfristig wartbarer Code und sehr gute Softwarequalität liegen dir am Herz?<br/>
                Projektbasiertes Arbeiten in einem tollen Team macht dir Spaß?<br/>
                Dann bewirb dich bei uns! Wir freuen uns auf deine Nachricht.
              </p>
              <button type="button" class="btn btn-info"
                      [routerLink]="['/contact']" fragment="contact-form"
                      [queryParams]="{subject: applicationContactFormSubject}" i18n>
                Kontaktformular öffnen
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section>
    <div class="card shear timeline">
      <div class="shear-inner bg-after bg-color-after">
        <div class="inner-content">
          <h1 class="text-center mb-4" i18n>Zeitleiste</h1>
          <div class="timeline-items">
            <div class="d-flex justify-content-lg-center justify-content-start timeline-start">
              <img ngSrc="assets/images/timeline_start.webp" alt="Start der Zeitleiste" i18n-alt height="60" width="60"/>
            </div>
            @for (event of timeline.valueOrDefault(); track event.id) {
              <div class="card p-0">
                <div class="timeline-bg">
                  <div [class.odd]="$odd" [class.flex-lg-row-reverse]="$even"
                       class="timeline-item d-flex flex-column flex-lg-row gap-1 gap-lg-5 align-items-start align-items-lg-center mx-5 ps-3 ps-lg-0 py-lg-3 text-start text-lg-center">
                    <h2 class="timeline-position mt-lg-0 flex-grow-1" [class.mt-3]="!$first">{{ event.pointInTime }}</h2>
                    <h2 class="timeline-event flex-grow-1" [innerHTML]="event.event | safeHtml"></h2>
                  </div>
                </div>
              </div>
            }
            <div class="d-flex justify-content-lg-center justify-content-md-start timeline-end">
              <img ngSrc="assets/images/timeline_after.webp" alt="Ende der Zeitleiste" i18n-alt height="60" width="60"/>
            </div>
            <h2 class="text-start text-lg-center mx-1 mx-lg-0" i18n>Heute</h2>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
